import React from "react";
import { withTheme, withStyles } from "@material-ui/core";

import MapView, { Marker, Popup, DrawingTools, MapConstant, Direction, MapControls, MarkerLayer} from "../../../../lib/Map";
import { TerminalMarker,DropYardMarker } from "../../../../components/mapComponents/Markers";
import {  StopPopupInfo, RoutePopupInfo, StopMovementPopupInfo, ShipmentPopupInfo ,AnchorPointPopupInfo, ZonePopUpInfo } from "../../../../components/mapComponents/Popups";
import {  getWayPoints, getLastStop, getRouteStopMarker, getShipmentMarker } from "../../../../components/mapComponents/mapHelper";
import { compose } from "recompose";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import appConstant from "../../../../appConstants";
import MESSAGES from "../../../../appMessages";
import {observer, inject } from "mobx-react";
import { isEqual } from "lodash/lang";
import { autorun } from "mobx";
import MapsHelper from "../../../../lib/Map/helper";
import { withSnackbar } from "notistack";
import Events from "../../../../utilities/EventEmitter";
import { postData } from "../../../../api/componentAPIs";
import StopMoveFeedbackPanel from "./StopMoveFeedbackPanel";
import { cloneDeep } from "lodash/lang";
import {trackEvent} from "../../../common/AppInsightsEventTracking";
import {withAppConfig} from "../../../../appConfigContext"
import { getSpecialNeeds } from "../../utils"

import LassoRoute from "../Common/LassoRoute";

const styles = theme => ({
    container:{
        position: 'absolute',
        margin:"40px 0px 0px 5px",
        backgroundColor: theme.ModalBGColor,
        top:0,
        zIndex:500,
    },
    logoContainer:{
        float:"right",
        padding: "5px",
        height: "20px"
    },
    routeDetails:{
        fontSize:14,
        fontWeight: 600,
        padding:"5px 10px"
    }
})
@inject ("IBPlanningStore", "CommonStore")
@observer
class MapsComponent extends React.Component {
    constructor(props){
        super(props);
        this.terminalLocation = this.props.userData.userProfile.terminal.location;
        this.headerId = `gridHeader_${this.props.glContainer._config.id}`;
        this.stopSelectedOnMap = false;
        this.markerForceUpdate = false;
        this.feedbackPanelKey = null;
        this.state ={
            terminalMarker: null,
            routesData: null,
            selectedStop: null,
            selectedRoute: null,
            selectedShipmentList:[],
            selectedShipment: null,
            themeChanged: true,
            currentTheme : this.props.theme.themeName,
            mapCenter: this.terminalLocation,
            selectedRouteNameList: this.props.IBPlanningStore.selectedRouteNameList.slice(),
            nearestStop: null,
            isStopMove: false,
            routeAnimation:true,
            enableRouteHover:true,
            zoneInfo:null,
            selectedStopColor:null,
            nearestStopColor:null,
            shipmentSelectionIsActive: false // this variable is used to track if a visible shipment was selected, keeping it active makes map recenter to the active shipment
        }
        this.stackContainer = this.props.glContainer.parent.parent;
        this.mapRef = React.createRef();
        this.userProfileData = {
            terminal:this.props.userData.userProfile.terminal.code,
            userName:this.props.userData.userProfile.userName,
            planDate:this.props.userData.userProfile.planDate
        }
        this.lassoBounds = [];
        this.isLassoActiveWithShipments = false
    }

    componentDidMount(){   
        this.props.glEventHub.on("routeAnimation", this.routeAnimation);
        this.props.glEventHub.on(appConstant.Event.STOP_SELECTED_GRID, this.stopsSelected);
        this.props.glEventHub.on('afterPrintEvent', this.onAfterPrint);
        this.props.glEventHub.on(
            "setIsLassoActiveWithShipments",
            this.setIsLassoActiveWithShipments
          );
        this.autorunDispose = autorun(()=>{
            if(!isEqual(this.state.selectedRouteNameList,this.props.IBPlanningStore.selectedRouteNameList)){
                this.hideAllPopups();
                // Updating lasso with new shipments when routes are added/removed from map
                if(this.state.showLasso){
                    this.onScaleDrawingComplete(this.lassoBounds, false);
                }
            }
            if(this.isSelectedStopRemoved()){
                this.setState({
                    selectedStop: null
                });
            }
            if(!isEqual(this.state.selectedShipmentList,this.props.IBPlanningStore.selectedShipmentIDList)){
                this.selectedShipmentChanged(this.props.IBPlanningStore.selectedShipmentIDList);
            }

            if(this.state.showLasso && !isEqual(this.filteredRouteShipments,this.props.IBPlanningStore.filteredRouteShipments)){
                // Updating lasso with new shipment when stops/shipments are moved to a different stop
                this.onScaleDrawingComplete(this.lassoBounds, false);
            }
        });
    }

    componentWillUnmount(){
        this.props.glEventHub.off("routeAnimation", this.routeAnimation);
        this.props.glEventHub.off(appConstant.Event.STOP_SELECTED_GRID, this.stopsSelected);
        this.props.glEventHub.off('afterPrintEvent', this.onAfterPrint);
        this.props.glEventHub.off(
          "setIsLassoActiveWithShipments",
          this.setIsLassoActiveWithShipments
        );
        this.autorunDispose && this.autorunDispose();
    }

    componentDidUpdate(prevProps){
        if(this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id && this.state.showLasso){
            this.onLassoClose();
        }
    }
    
    setIsLassoActiveWithShipments = (isLassoActiveWithShipments) => {
        this.isLassoActiveWithShipments = isLassoActiveWithShipments;
    }
    
    static getDerivedStateFromProps(nextProps, state){
        return {
            themeChanged: nextProps.theme.themeName !== state.currentTheme,
            currentTheme: nextProps.theme.themeName,
            mapCenter: nextProps.userData.userProfile.terminal.location
        }
    }
    routeAnimation = routeAnimation => {
        this.setState({
            routeAnimation
        })
    }
    onAfterPrint=()=>{
        const userProfile = this.props.userData.userProfile;
        const eventSpecificData = {
            routesPrinted: this.props.IBPlanningStore.selectedRouteNameList.join(",")
        }
        trackEvent("RoutesMapPrint", userProfile, eventSpecificData);
    }
    isSelectedStopRemoved = () => {

        if(this.props.IBPlanningStore.filteredRouteStops && this.props.IBPlanningStore.filteredRouteStops.length > 0 ){
            return this.state.selectedStop && !this.props.IBPlanningStore.filteredRouteStops.find(stop => stop.routeStopId === this.state.selectedStop.data.routeStopId);
        }
        return true;
    }

    stopsSelected = (stopIDList) => {
        this.stopSelectedOnMap = false;
        this.hideAllPopups();
        if(this.props.IBPlanningStore.filteredRouteStops && this.props.IBPlanningStore.filteredRouteStops.length > 0){
            if(stopIDList.length === 1){
                const stop = this.props.IBPlanningStore.filteredRouteStops.find(stop=>stopIDList[0]===stop.routeStopId);
                if(stop){
                   // const stopLocation = {lat: stop.latitude, lng: stop.longitude};
                    this.setState({
                        selectedStop: { data: stop }
                    });
                }
            }
        }
    }


    isShipmentVisibleOnMap = (proIdList) => {
        let shipmentRoutes = this.props.IBPlanningStore.filteredRouteShipments.filter(shipment => proIdList.includes(shipment.proId))
                                                                              .map(shipment => shipment.routeName);
        shipmentRoutes = [...new Set([...shipmentRoutes])]; // find unique routeNames for selected shipments
        let deliveryRoutes = this.props.IBPlanningStore.deliveryRouteNameList.filter(route => shipmentRoutes.includes(route.label)) || [];
        return shipmentRoutes.length !== deliveryRoutes.length; // if both are not equal one of shipment is from trap route and visible on map, close other popups in this changes
    }

    selectedShipmentChanged = (proIdList) => {
        let mapCenter = {};
        if (proIdList.length === 1) {
            const shipment = this.props.IBPlanningStore.filteredRouteShipments.find(shipment => shipment.proId === proIdList[0]);

            if(shipment){
                mapCenter = { lat: shipment.latitude, lng: shipment.longitude };
            }
        }

        const otherStateProperties = this.isShipmentVisibleOnMap(proIdList) ? {
            terminalMarker: null,
            selectedRoute: null,
            zoneInfo:  null,
            selectedStop: null,
            shipmentSelectionIsActive: true,
            mapCenter
        } : {};

            this.setState((state) => ({
                selectedShipmentList: !isEqual(state.selectedShipmentList, proIdList) ? [...proIdList] : state.selectedShipmentList,
                selectedShipment: state.selectedShipment && proIdList.length ===1 && proIdList.includes(state.selectedShipment.proId) ? state.selectedShipment : null,
                ...otherStateProperties
            }));
    }

    onMapClicked = () => {
        this.hideAllPopups();
    }

    onTerminalClicked = ({marker}) =>{
        this.setState({
            terminalMarker: marker,
            selectedStop: null,
            selectedRoute: null,
            zoneInfo: null,
            selectedShipment: null,
            shipmentSelectionIsActive: false,
        })
    }

    onRouteStopClicked = (stop) => {
        this.stopSelectedOnMap = true;
        this.setState({
            selectedStop: stop,
            terminalMarker: null,
            selectedRoute: null,
            zoneInfo: null,
            selectedShipment: null,
            shipmentSelectionIsActive: false,
        });
      //  if(this.stopSelectedOnMap){
            this.props.glEventHub.emit(appConstant.Event.STOP_SELECTED_MAP, stop.data.routeStopId);
      //  }
        
    }

    onRouteClicked = (route) => {
        this.setState({
            selectedRoute: route,
            terminalMarker: null,
            selectedStop: null,
            zoneInfo: null,
            selectedShipment: null,
            shipmentSelectionIsActive: false,
        })
    }

    onShipmentMarkerClicked = (shipment) => {
        const shipmentAlreadySelected =  this.state.selectedShipmentList.includes(shipment.proId);
        const updatedSelectedShipments = shipmentAlreadySelected
          ? this.state.selectedShipmentList
          : [shipment.proId];
        //this.props.IBPlanningStore.updateSelectedShipments(updatedSelectedShipments);
        this.props.glEventHub.emit("UpdateIBStore", "updateSelectedShipments", [
          updatedSelectedShipments,
        ]);
        this.setState({
            selectedShipment: shipment ,
            selectedShipmentList: shipmentAlreadySelected ? this.state.selectedShipmentList:  [shipment.proId],
            terminalMarker: null,
            selectedRoute: null,
            zoneInfo: null,
            selectedStop: null,
            shipmentSelectionIsActive: true
        });
       
    }

    hideAllPopups = () => {
        this.setState({
            terminalMarker: null,
            selectedRoute: null,
            selectedStop: null,
            selectedShipment: null,
            zoneInfo: null,
            selectedRouteNameList:this.props.IBPlanningStore.selectedRouteNameList.slice(),
            shipmentSelectionIsActive: false,
        });
        this.stopSelectedOnMap = false;
    }
    onMarkerDragStart =(stop)=>{
        this.markerForceUpdate = false;
        this.setState({
            selectedStop: stop,
            isStopMove: true,
            enableRouteHover:false,
            shipmentSelectionIsActive: false,
        });

    }
    onMarkerDrag =(stop)=>{
        if(this.state.isStopMove){
            let nearestStop =  MapsHelper.getNearestPoint(stop.marker._lngLat,this.currentStopsData);
            const selectedStopData = this.props.IBPlanningStore.routeWithStops.find(route=>route.routeName === stop.data.routeName);
            const nearestStopData = this.props.IBPlanningStore.routeWithStops.find(route=>route.routeName === nearestStop.routeName);
            if(!this.state.nearestStop || this.state.nearestStop.routeStopId !== nearestStop.routeStopId){
                this.setState({
                    nearestStop: nearestStop,
                    selectedStop: stop,
                    selectedStopColor:selectedStopData.color,
                    nearestStopColor:nearestStopData.color
                })
            }
        }
    }

    onMarkerDragEnd =(stop)=>{
        this.markerForceUpdate = true;
        if(!this.state.nearestStop ||!this.state.selectedStop){
            return;
        }
        // console.log("Data", JSON.parse(JSON.stringify(this.props.IBPlanningStore.routeWithStops.routeStops)));
        if(this.state.nearestStop.routeStopId === this.state.selectedStop.data.routeStopId){
            stop.marker.setLngLat({lng: this.state.nearestStop.longitude, lat: this.state.nearestStop.latitude})
        }
        else if(this.state.nearestStop.stopType==="AP"){
            stop.marker.setLngLat({lng: this.state.selectedStop.data.longitude, lat: this.state.selectedStop.data.latitude})
        }
        else if(this.state.nearestStop.routeId === this.state.selectedStop.data.routeId){
            let updatedSourceStop = this.state.selectedStop.data.stopSequence;
            let updatedDestinationStop = this.state.nearestStop.stopSequence;
            let routesData = this.props.IBPlanningStore.routeWithStops.map(route=>{
                const  routeStops  = cloneDeep(route.routeStops);
                // cloning and updating the stop properties so that they dont create multiple intermediate request for directions API
                routeStops.map(stop=> {
                    if(stop.routeStopId === this.state.selectedStop.data.routeStopId){
                        stop.stopSequence = updatedDestinationStop;
                        stop.isLastStop=false;
                        stop.isFirstStop=false;
                    }
                    if(stop.routeStopId === this.state.nearestStop.routeStopId){
                        stop.stopSequence = updatedSourceStop;
                        stop.isLastStop=false;
                        stop.isFirstStop=false;
                    }
                    return stop;
                })
            route.routeStops = routeStops;
            return route;
        });
            const allRouteStops = routesData.map(route=>route.routeStops);
            const allStops=[];
            allRouteStops.forEach(routeStops => {
                allStops.push(...routeStops)
            });
          //this.props.IBPlanningStore.setReseqeuncedRouteStops(allStops);
          this.props.glEventHub.emit("UpdateIBStore", "setReseqeuncedRouteStops", [allStops]);
            this.updateStops(this.state.nearestStop.routeId, this.state.nearestStop.routeName);

        }
        else if(this.state.nearestStop.routeId !== this.state.selectedStop.data.routeId){
            let updatedSourceStop = this.state.selectedStop.data.stopSequence;
            let updatedDestinationStop = this.state.nearestStop.stopSequence;
            let routesData = this.props.IBPlanningStore.routeWithStops.map(route=>{
                if(route.routeId === this.state.selectedStop.data.routeId){
                   route.routeStops = route.routeStops.filter(stop=>{
                        if(stop.routeStopId !== this.state.selectedStop.data.routeStopId){
                            return stop;
                        }
                    });
                }
                else if(route.routeId === this.state.nearestStop.routeId){
                    route.routeStops = route.routeStops.map(stop=>{
                        if(stop.stopSequence >= updatedDestinationStop){
                            stop.stopSequence +=1;
                            stop.isFirstStop= false;
                            //stop.isLastStop= false;
                        }
                        return stop;
                    }
                    );
                    let stopToBeMoved = this.state.selectedStop.data;
                    stopToBeMoved.stopSequence = updatedDestinationStop;
                    stopToBeMoved.isFirstStop= false;
                    stopToBeMoved.isLastStop= false;
                    route.routeStops.push(stopToBeMoved);
                }
                return route;
            });
            this.updateRouteStops(routesData.find(route=>route.routeId===this.state.nearestStop.routeId));
        }
        this.setState({
            isStopMove: false,
            selectedStop: null,
            nearestStop: null,
            enableRouteHover:true
        })
    }
    updateRouteStops=(routeObj)=>{
        const requestObj = {
            routeId: routeObj.routeId,
            scenarioId: this.props.userData.userProfile.scenarioID,
            routeName: routeObj.routeName,
            stops: routeObj.routeStops.map(stop=>({
				routeStopId: stop.routeStopId, 
				sequence: stop.stopSequence,
				isFirstStop: stop.isFirstStop, 
				isLastStop: stop.isLastStop, 
				routeName: stop.routeName,
				routeId: stop.routeId
			}))
        }
        const [successRoutes , failureRoutes] = [[],[]];
        //this.props.IBPlanningStore.setdisableStoreUpdate(true);
        this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [true]);
        this.props.closeSnackbar(); //Closes other snackbars
        postData("UpdateRouteStopsFromMap", requestObj).then(response => {
            if (response && response.status >=200 && response.status< 400) {
                if(response.data && response.data.routes){
                    response.data.routes.map(route => {
                        if(route.success){
                            successRoutes.push(route.routeName);
                        }else{
                            failureRoutes.push(route.routeName);
                        }
                    })
                    if(response.data.feedback){
                        const  feedbackData = {
                            ...response.data.feedback,
                            routesAffected: [...successRoutes,...failureRoutes].join(", "),
                            scenarioVersionId:response.data.scenarioVersionId,
                            scenarioId: this.props.userData.userProfile.scenarioID,
                        }

                        this.feedbackPanelKey = this.props.enqueueSnackbar("Stop Route Changed", {
                            children: <StopMoveFeedbackPanel
                                        open
                                        moveType={appConstant.STOP_MOVES.CHANGE_ROUTE}
                                        data={feedbackData}
                                        onClose={this.onCloseFeedbackPanel}
                                        refreshData={this.refreshData}
                                        selectedRouteList={this.state.selectedRouteNameList}
										glEventHub={this.props.glEventHub}
                                    />,
                            autoHideDuration:30000,
                            style:{pointerEvents: "none"}
                        });
                    }else{
                        this.props.enqueueSnackbar(MESSAGES.STOP_MOVE.SUCCESS,{variant: "success"});
                    }
                }
                if(failureRoutes.length > 0){
                    this.props.enqueueSnackbar(`Optimization failed for routes ${failureRoutes.join(", ")}`,{variant: "error"});
                }
                //Events.emit("RefreshIBStore", false, this.props.IBPlanningStore.selectedRouteNameList);
                this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [false, this.props.IBPlanningStore.selectedRouteNameList]);
            }else{
                this.props.enqueueSnackbar(MESSAGES.STOP_MOVE.FAILURE,{variant: "error"});
                 if(!(response && response.response && response.response.status === 409)){
                   this.props.glEventHub.emit("UpdateIBStore", "refreshFilterStops", []);
                   this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [false]);
                }
            }
        }, error=>{
            this.props.enqueueSnackbar(MESSAGES.STOP_MOVE.FAILURE,{variant: "error"});
            //this.props.IBPlanningStore.refreshFilterStops();
            //this.props.IBPlanningStore.setdisableStoreUpdate(false);
            this.props.glEventHub.emit("UpdateIBStore", "refreshFilterStops", []);
            this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [false]);
        }).then(()=>{
            //Log telemetry
              const userProfile =this.props.userData.userProfile;
              const eventSpecificData = {
                  routes: [...successRoutes,...failureRoutes].join(", ")
              }
              trackEvent("StopMoveBetweenRoutesOnMap", userProfile, eventSpecificData);
          });
    }
    updateStops=(routeId, routeName)=>{
        const stopsTobeFiltered = this.props.IBPlanningStore.filteredRouteStops.filter(stop=>stop.routeId===routeId)
        const updatedStopSequence = {
            scenarioId: this.props.userData.userProfile.scenarioID,
			routeId: routeId,
			routeName: routeName,
            stops: stopsTobeFiltered.map(stop => ({
			  routeStopId: stop.routeStopId,
              sequence: stop.stopSequence,
              isLastStop: stop.isLastStop,
              isFirstStop: stop.isFirstStop
            }))
          }
          //this.props.IBPlanningStore.setdisableStoreUpdate(true);
          this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [true]);
          this.props.closeSnackbar(); //Closes other snackbars
          const [successRoutes , failureRoutes] = [[],[]];
          postData("UpdateStopSequence",updatedStopSequence).then(response => {
            if(response && response.status >=200 && response.status < 400){
                if(response.data && response.data.routes){
                    response.data.routes.map(route => {
                        if(route.success){
                            successRoutes.push(route.routeName);
                        }else{
                            failureRoutes.push(route.routeName);
                        }
                    })
                }
                if(response.data.feedback){
                    const  feedbackData = {
                        ...response.data.feedback,
                        routesAffected: [...successRoutes,...failureRoutes].join(", "),
                        scenarioVersionId:response.data.scenarioVersionId,
                        scenarioId: this.props.userData.userProfile.scenarioID,
                    }

                    this.feedbackPanelKey = this.props.enqueueSnackbar("Stops Resequenced", {
                        children: <StopMoveFeedbackPanel
                                    open
                                    moveType={appConstant.STOP_MOVES.RESEQUENCE}
                                    data={feedbackData}
                                    onClose={this.onCloseFeedbackPanel}
                                    refreshData={this.refreshData}
									glEventHub={this.props.glEventHub}
                                />,
                        autoHideDuration: 30000,
                        style:{pointerEvents: "none"}
                    });
                } else{
                    this.props.enqueueSnackbar(MESSAGES.STOP_MOVE.SUCCESS,{variant: "success"});
                }

                if(failureRoutes.length > 0){
                    this.props.enqueueSnackbar(`Optimization failed for routes ${failureRoutes.join(", ")}`,{variant: "error"});
                }


                //Events.emit("RefreshIBStore", false, this.props.IBPlanningStore.selectedRouteNameList);
                this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [false, this.props.IBPlanningStore.selectedRouteNameList]);
            } else {
                this.props.enqueueSnackbar(MESSAGES.STOP_MOVE.FAILURE, {variant: "error"});
                 if(!(response && response.response && response.response.status === 409)){
                    this.props.glEventHub.emit("UpdateIBStore", "refreshFilterStops", []);
                    this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [false]);
                 }
            }
          }, error=>{
                this.props.enqueueSnackbar(MESSAGES.STOP_MOVE.FAILURE, {variant: "error"});
                // this.props.IBPlanningStore.refreshFilterStops();
                // this.props.IBPlanningStore.setdisableStoreUpdate(false);
                this.props.glEventHub.emit("UpdateIBStore", "refreshFilterStops", []);
                this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [false]);
          }).then(()=>{
              //Log telemetry
                const userProfile =this.props.userData.userProfile;
                const eventSpecificData = {
                    routes: [...successRoutes,...failureRoutes].join(", ")
                }
                trackEvent("StopMoveWithInRoutesOnMap", userProfile, eventSpecificData);
            });
        }
    onCloseFeedbackPanel = () => {
        if(this.feedbackPanelKey !== null){
            this.props.closeSnackbar(this.feedbackPanelKey);
            this.feedbackPanelKey = null;
        }
    }

    onZoneClicked=(zoneInfo)=>{
        this.setState({
            terminalMarker: null,
            selectedRoute: null,
            selectedStop: null,
            selectedShipment: null,
            zoneInfo,
            selectedRouteNameList:this.props.IBPlanningStore.selectedRouteNameList.slice()
        });
        this.stopSelectedOnMap = false;
    }

    isShipmentActive = (currentProId) => {
        return this.state.shipmentSelectionIsActive && this.state.selectedShipmentList.find(proId=> proId === currentProId);
    }
    selectedRoutesFromStopPopUp=(selectedRouteNames)=>{
        this.props.glEventHub.emit("UpdateIBStore", "updateSelectedRoutes", [selectedRouteNames]);
    }
    showNotification=(message, type="info")=>{
        this.props.enqueueSnackbar(message, {variant: type});
        this.hideAllPopups();
    }
    refreshData=(selectedRouteNameList = this.props.IBPlanningStore.selectedRouteNameList)=>{
        //Events.emit("RefreshIBStore", false, selectedRouteNameList);
        this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [false, selectedRouteNameList]);
    }


    onScaleDrawingComplete = (bounds, isNewLasso = true) => {
        this.lassoBounds = bounds;
        let lassoShipments = [];
        this.filteredRouteShipments = [...this.props.IBPlanningStore.filteredRouteShipments];
        if(this.props.IBPlanningStore.selectedRouteNameList.length){
            lassoShipments = MapsHelper.getLocationWithinBounds(bounds,this.props.IBPlanningStore.filteredRouteShipments)
        }
        this.setState({
            lassoShipments,
            showLasso: true,
            isNewLasso
        });
        this.mapRef.current.classList.add('mapContainerWithLasso');
    }

     onLassoClose = () => {
        this.mapRef.current.classList.remove('mapContainerWithLasso');
         this.setState({
             showLasso: false,
             lassoShipments:[]
         });
         this.props.glEventHub.emit("mapResize");
    }

    getDropYard=(dropYardId)=>{
       return this.props.CommonStore.dropYardList.find(dropYard=>dropYard.dropYardId === dropYardId) || null;
    }

    getDropYardLocation=(dropYardId)=>{
        const dropYardData = this.getDropYard(dropYardId);
        return dropYardData ? {
            lat: dropYardData.latitude,
            lng: dropYardData.longitude,
          } : null;
     }

     getShipmentIcon = (shipment) => {
        return getShipmentMarker({
            shipmentData: shipment,
            theme: this.props.theme,
            isActiveShipment: this.isShipmentActive(shipment.proId),
          });
     }

    getMarkerLayerCenter = () => {
        // If a single marker is slected on grid or on Map move map to make that shipment as center
        const { selectedShipment, selectedShipmentList } = this.state;
        if (selectedShipment) {
            return {
            lat: selectedShipment.latitude,
            lng: selectedShipment.longitude,
            };
        } else if (selectedShipmentList.length === 1) {
            const selShipment = this.props.IBPlanningStore.routeWithStops
            ?.flatMap((route) => route.routeShipments)
            ?.find((shipment) => selectedShipmentList.includes(shipment.proId));
            if (selShipment) {
            return { lat: selShipment.latitude, lng: selShipment.longitude };
            }
        }
        return null;
    };
  
    render(){
        const routesData = this.props.IBPlanningStore.routeWithStops;
        const dropYardIdList = [...new Set(routesData.map((route)=>route.dropYardId)?.filter(Boolean))];
        const dropYardList = dropYardIdList.length > 0 ? dropYardIdList.map((dropYard)=>this.getDropYard(dropYard))?.filter(Boolean) || [] :[];
        const disableStoreUpdate = this.props.IBPlanningStore.disableStoreUpdate;
        this.terminalLocation = this.props.userData.userProfile.terminal.location;
        if(routesData.length> 0) {
            this.currentStopsData = routesData.reduce((acc, val)=>{
                acc.push(...val.routeStops)
                return acc;
            },[]);
        }
        const { theme } = this.props;
        return(
            <div ref={this.mapRef}>
                <div className="onlyPrint">
                 <img src="../../images/RouteMax_Logo_Print.svg" className={this.props.classes.logoContainer} />
                {
                    routesData?.length > 0?
                        <div className={`${this.props.classes.container} onlyPrint`}>
                            { routesData.map(route => (
                                <div className={this.props.classes.routeDetails} style={{color: route.color}} key={route.routeName}>
                                    Route {route.routeName} : {route.routeStops.length} stops
                                </div>
                              ))
                            }
                        </div>
                        : null
                }
                </div>
                <MapView
                    zoom={9}
                    initialCenter={this.terminalLocation}
                    center={this.state.mapCenter}
                    onClick={this.onMapClicked}
                    mapId={"routesMap"}
                    mapTheme={theme.themeName}
                    eventHub={this.props.glEventHub}
                    enablePrint
                    mapConfig = {this.props.configJSON?.maps}
                >
                <MarkerLayer
                  code={this.props.userData.userProfile.terminal.code}
                  data={
                    routesData?.flatMap((route) => route.routeShipments) ?? []
                  }
                  dataKey={"proId"}
                  activeMarkerIds={this.state.selectedShipmentList.slice()}
                  getIcon={this.getShipmentIcon}
                  center={this.getMarkerLayerCenter()}
                  onClick={this.onShipmentMarkerClicked}
                  showTooltip
                />
                    <DrawingTools
                       // forceRender updates the options of drawing Manager && updates the configurations of drawings already drawn on map
                       // set to true when theme changes
                       forceRender={this.state.themeChanged}
                       rectangleOptions = {
                           {
                               fillColor: theme.MapDrawingColor,
                               strokeColor: theme.MapDrawingColor,
                           }
                       }
                       polylineOptions = {
                           {
                               strokeColor: theme.MapDrawingColor,
                           }
                       }
                       polygonOptions = {
                           {
                               fillColor: theme.MapDrawingColor,
                               strokeColor:  theme.MapDrawingColor,
                           }
                       }
                       eventHub={Events}
                        onDrawingComplete={this.onScaleDrawingComplete}
                       />

                       <MapControls
                         controlOptions = {
                             {
                                //  fullscreenControl: {
                                //      position: MapConstant.CONTROL_POSITION.TOP_RIGHT
                                //  },
                                 zoomControl: {
                                     position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT
                                 },
                                 satelliteViewControl: {
                                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT
                                 },
                                 reCenterMapControl: {
                                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT
                                 },
                                 showZones: {
                                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                                    terminalID: this.props.userData.userProfile.terminal.code,
                                    onZoneClicked: this.onZoneClicked,
                                    geoJson: this.props.userData.userProfile?.geoJson
                                 }
                             }
                         }
                         />

                    <Marker
                        position={this.terminalLocation}
                        onClick={this.onTerminalClicked}
                        animation
                        // anchor point is the point in the image which should overlap the location,
                        // Terminal image is of different size than the marker so we can override the default value as shown below
                        anchorPoint={{x:20,y:20}}
                        zIndex={1}
                        forceUpdate={true}
                        isActiveShipment={true}
                    >
                        <TerminalMarker data={this.props.userData.userProfile.terminal} color={theme.terminalContentColor}/>

                    </Marker>

                 {dropYardList.length>0 && dropYardList.map((dropYard) => {  return (
                     <Marker
                      data={dropYard}
                      position={{
                        lat: dropYard.latitude,
                        lng: dropYard.longitude,
                      }}
                      key={dropYard.dropYardCode}
                      forceUpdate={false}
                      isActiveShipment={false}
                      zIndex={1}
                    >
                     <DropYardMarker
                        data={{
                          name: dropYard.dropYardName,
                          address: dropYard.address                        
                        }}
                      />
                    </Marker>
                  )})}

                    { routesData?.map && routesData.map?.(route => (
                            (route.routeName != appConstant.UNRTD_ROUTENAME && !route.isTrapRoute) &&
                                route.routeStops?.length > 0 && route.routeStops.map(stop=>(
                                <Marker
                                    data={{...stop, isLocked: route.isLocked}}
                                    position={{ lat: stop.latitude, lng: stop.longitude }}
                                    key={`${stop.routeStopId}`}
                                    onClick={this.onRouteStopClicked}
                                    zIndex= {stop.routeStopId===(this.state.selectedStop?.data?.routeStopId)?2:1}
                                    draggable={!(route.isLocked || stop.stopType === "AP" || disableStoreUpdate) }
                                    onDragStart={this.onMarkerDragStart}
                                    onDrag={this.onMarkerDrag}
                                    onDragEnd={this.onMarkerDragEnd}
                                    forceUpdate={this.markerForceUpdate}
                                >
                                    {getRouteStopMarker({stopData: stop,
                                                        theme: theme.themeName,
                                                        borderColor: this.state.nearestStop && stop.routeStopId===this.state.nearestStop.routeStopId?theme.SelectedStopBorderColor:theme.routeMapColorPalette.MarkerBorderColor,
                                                        markerTextColor: stop.stopType === "AP" ? theme.AnchorTextColor : theme.routeMapColorPalette.MarkerTextColor,
                                                        color: stop.stopType === "AP" ? theme.AnchorBGColor : route.color,
                                                        isSelectedStop: stop.routeStopId===(this.state.selectedStop && this.state.selectedStop.data.routeStopId)})}
                                </Marker>
                              ))
                        ))
                    }


                    {  routesData?.map?.(route => (
                        !route.isTrapRoute &&  route.routeStops?.length > 0 && (
                            <Direction
                                origin={route.dropYardId && dropYardList.length>0? this.getDropYardLocation(route.dropYardId) : this.terminalLocation}
                                destination={getLastStop(route.routeStops)}
                                waypoints={getWayPoints(route.routeStops)}
                                strokeColor={route.color}
                                onClick={this.onRouteClicked}
                                data={route}
                                key={route.routeName} //routeId changes for each update which will unmount this component
                                zIndex={0}
                                routeAnimation={this.state.routeAnimation && !this.isLassoActiveWithShipments}
                                enableRouteHover={this.state.enableRouteHover}
                                hoverContent={`<div>Route : ${route.routeName}</div><div>${Math.floor(route.totalTime/60)}h ${route.totalTime%60}min</div>`}
                            />
                        )))
                    }

                    { this.state.selectedStop && this.stopSelectedOnMap && (
                        <Popup
                            marker={this.state.selectedStop.marker}
                            // forceRender will rerender the child component into the infowindow,
                            // set to true when theme changes or data is updated for selected shipment
                            forceRender={this.state.themeChanged}
                        >
                         {
                             this.state.selectedStop.data.stopType === "AP" ? (
                                 <AnchorPointPopupInfo
                                    data={this.state.selectedStop.data}
                                    theme={this.props.theme.themeName}
                                    scenarioID={this.props.userData.userProfile.scenarioID}
                                    showNotification={this.showNotification}
                                    refreshData={this.refreshData}
                                    userProfile={this.userProfileData}
                                 />

                             ) : (
                                <StopPopupInfo
                                    data={this.state.selectedStop.data}
                                    theme={this.props.theme.themeName}
                                    scenarioID={this.props.userData.userProfile.scenarioID}
                                    selectedRoutes={this.selectedRoutesFromStopPopUp}
                                    showNotification={this.showNotification}
                                    refreshData={this.refreshData}
                                    userProfile={this.userProfileData}
									glEventHub={this.props.glEventHub}
                                    specialNeedsOptions={getSpecialNeeds(
                                        this.props.IBPlanningStore.serviceLevelList , appConstant.STOP_GRID_SPECIAL_NEEDS
                                    )}
                                    showDateRangeInShipmentSelection = {this.props.configJSON?.showDateRangeInShipmentSelection}
                                 />
                             )
                         }

                        </Popup>
                    )}

                    { this.state.selectedRoute && (
                        <Popup
                            position={this.state.selectedRoute.position}
                            // forceRender will rerender the child component into the infowindow,
                            // set to true when theme changes or data is updated for selected shipment
                            forceRender={this.state.themeChanged}
                        >
                            <RoutePopupInfo
                                data={routesData.find(route => route.routeName === this.state.selectedRoute.data.routeName)} // To keep routePopup upto date when it is open and route info is updated
                                theme={this.props.theme.themeName}
                                scenarioID={this.props.userData.userProfile.scenarioID}
                            />
                        </Popup>
                    )}

                    {
                        this.state.selectedShipment &&  (
                            <Popup
                                // marker={this.state.selectedShipment.marker}
                                // forceRender will rerender the child component into the infowindow,
                                // set to true when theme changes or data is updated for selected shipment
                                position={{ lat: this.state.selectedShipment.latitude, lng: this.state.selectedShipment.longitude }}
                                forceRender={this.state.themeChanged}
                                key={`${this.state.selectedShipment.proId}_shipmentPopup`}
                            >
                                <ShipmentPopupInfo
                                    data={this.state.selectedShipment}
                                    theme={this.props.theme.themeName}
                                    specialNeedsOptions={getSpecialNeeds(
                                    this.props.IBPlanningStore.serviceLevelList
                                    )}
                                />
                            </Popup>
                        )
                    }


                    {/* { this.state.terminalMarker && (
                        <Popup
                            marker={this.state.terminalMarker}
                            // forceRender will rerender the child component into the infowindow,
                            // set to true when theme changes or data is updated for Terminal
                            forceRender={this.state.themeChanged}
                        >
                            <TerminalPopupInfo data={this.props.userData.userProfile.terminal}  theme={this.props.theme.themeName}/>
                        </Popup>
                    )} */}

                    {this.state.nearestStop && this.state.selectedStop &&  this.state.selectedStop.marker && (
                        <Popup
                            marker={this.state.selectedStop.marker}
                        >
                            <StopMovementPopupInfo
                            nearestStop={this.state.nearestStop}
                            selectedStop={this.state.selectedStop.data}
                            theme={this.props.theme.themeName}
                            selectedStopColor={this.state.selectedStopColor}
                            nearestStopColor={this.state.nearestStopColor}
                            />
                        </Popup>
                    )}
                    {
                        this.state.zoneInfo  && (
                            <Popup
                                isCloseButton
                                position={this.state.zoneInfo.position}
                            >
                            <ZonePopUpInfo data={this.state.zoneInfo.data}/>
                        </Popup>)

                    }
                </MapView>
                { this.state.showLasso && (
                        <LassoRoute
                                open={this.state.showLasso}
                                container={this.stackContainer.element[0]}
                                shipments={this.state.lassoShipments}
                                onClose={this.onLassoClose}
                                scenarioId={this.props.userData.userProfile.scenarioID}
                                userProfile={this.userProfileData}
                                currentView={"Routes"}
                                isNewLasso={this.state.isNewLasso}
                                glEventHub={this.props.glEventHub}
                            />
                    )}
            </div>

        )
    }
}
export default compose(withStyles(styles),withTheme(), withUserProfile, withSnackbar,withAppConfig)(MapsComponent);
